import { apiNWL, apiController, restartApiCotroller } from '@/utils/nwlApi';

const DEFAULT_PAGE_SIZE = Number(process.env.VITE_DEFAULT_DECISION_LOG_PAGE_SIZE) || 10;

const getDecisionLogData = ({orgId, locId, page = 1, pageSize = DEFAULT_PAGE_SIZE, startDate, endDate, mode} : {orgId : string, locId: string, page?: number, pageSize?: number, startDate? : number | undefined, endDate? : number | undefined, mode? : string | undefined})  => {
    const offset = (page - 1) * pageSize;
    const url = `/organisations/${orgId}/locations/${locId}/scada/events/smart-control?offset=${offset}&limit=${pageSize}&value=1${startDate ? `&start=${startDate}` : ''}${endDate ? `&end=${endDate}` : ''}${mode ? `&mode=${mode}` : ''}`;
    const historic = async () => await apiNWL.get(url);

    return ({
        historic: historic().then((response) => response.data)
    });
};

const getModes = async (locId, orgId) => {
    try {
        restartApiCotroller();
        const response = await apiNWL.get(`/organisations/${orgId}/locations/${locId}/scada/events/smart-control/modes`, {
            signal: apiController.signal,
        });
        return response.data || {};
    } catch (error) {
        console.error(error);
    }
};

export {getDecisionLogData, getModes};